import styled from 'styled-components';

export const ButtonWrapper = styled.div<{ $isHidden: boolean }>`
  display: inline-block;
  visibility: ${({ $isHidden }) => ($isHidden ? 'hidden' : 'visible')};
  position: relative;
  z-index: 2;
`;
